"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBacker = exports.isPausedSubscription = void 0;
const types_1 = require("@fluent-forever/types");
const isPausedSubscription = (state) => state.subscriptionStatus === types_1.SubscriptionStatusEnum.Paused;
exports.isPausedSubscription = isPausedSubscription;
const isBacker = (state) => state.isBacker;
exports.isBacker = isBacker;
//# sourceMappingURL=subscription.js.map